import SaudabookMoengageEvents from './saudabook-pwa';
import FarmartMoengageEvents from './farmart-web';
import FarmartAIEvent from './farmart-ai';

import { isFarmartWeb } from '@mono-farmart-web/common-utils/utils/common';

const Events: any = isFarmartWeb
	? FarmartMoengageEvents
	: SaudabookMoengageEvents;

const CombinedEvents = {
	...Events,
	...FarmartAIEvent,
} as const;

export default CombinedEvents;
